import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import Vue from 'vue'
import { CbosProps, UseCbosState } from './types'
import { RequestOptionsProps } from '../types'
import useLoading from '../useLoading'

const useCbos = (() => {
  const state = Vue.observable<UseCbosState>({
    fetchedCbos: false,
    cbos: [],
  })

  const { closeLoading, showLoading } = useLoading()

  function setCbos(data: CbosProps[]) {
    state.cbos = data
  }

  async function loadCbos({
    showLoading: shouldShowLoading = true,
    forceRefresh = false,
    showToastError = true,
  }: RequestOptionsProps = {}) {
    if (state.fetchedCbos && !forceRefresh) {
      return { success: true, data: state.cbos }
    }
    if (shouldShowLoading) showLoading()
    const response = await Apis.Cadastro.CadastroApi.getCbosAll()
    if (response.success) {
      setCbos(response.data)
      state.fetchedCbos = true
    } else if (showToastError) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro na requisição.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    closeLoading()
    return response
  }

  return {
    get cbos() {
      return state.cbos
    },
    loadCbos,
    setCbos,
  }
})()

export default useCbos
